var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"info","fab":"","x-small":"","to":'/Project/ViewCasepending/Nonhp/' +
                        _vm.maincaseid +
                        '/' +
                        'ViewDetail',"target":"_blank"}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-magnify")])],1)]}}])},[_c('span',[_vm._v("View Case")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }